export default __webpack_public_path__ + "static/media/lamonterra.f191c79e.png";